import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

export abstract class AbstractModal {
    protected constructor(protected ngbActiveModal: NgbActiveModal) {
    }
    close(data?: any): void {
        this.ngbActiveModal.close(data);
    }
}
